const env = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {}
const appMode = env.MODE ?? (env.PROD ? 'production' : 'development')
if (typeof globalThis !== 'undefined' && typeof globalThis.mode === 'undefined') {
  Object.defineProperty(globalThis, 'mode', {
    value: appMode,
    writable: true,
    configurable: true,
    enumerable: true,
  })
}
